// aws-appsync-auth-link expects Node's global object during module evaluation.
window.global ||= window;
